type VersionSource =
  | Date
  | number
  | string
  | { toDate?: () => Date }
  | null
  | undefined;

const isHttpUrl = (value: string): boolean =>
  value.startsWith('http://') || value.startsWith('https://');

const resolveVersionToken = (source: VersionSource): string => {
  if (source === null || source === undefined) return '';

  if (typeof source === 'number') {
    return Number.isFinite(source) ? String(source) : '';
  }

  if (typeof source === 'string') {
    const numeric = Number(source);
    if (Number.isFinite(numeric)) return String(Math.trunc(numeric));
    const parsed = new Date(source);
    return Number.isNaN(parsed.getTime()) ? '' : String(parsed.getTime());
  }

  if (source instanceof Date) {
    return Number.isNaN(source.getTime()) ? '' : String(source.getTime());
  }

  if (typeof source.toDate === 'function') {
    const converted = source.toDate();
    return Number.isNaN(converted.getTime()) ? '' : String(converted.getTime());
  }

  return '';
};

export const withImageVersion = (url: string, versionSource?: VersionSource): string => {
  if (!url || !isHttpUrl(url)) return url;
  const token = resolveVersionToken(versionSource);
  if (!token) return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}v=${encodeURIComponent(token)}`;
};
